var RunCandidateScore = /** @class */ (function () {
    function RunCandidateScore(companyId, userId) {
        this.companyId = companyId;
        this.userId = userId;
        this.candidateId;
        this.jobId;
        this.jobMatchId;
        this.rerunType; // "CANDIDATE/CANDIDATE_JOB/REQUISITION/GLOBAL"
        this.candidateType;
    }
    return RunCandidateScore;
}());
export { RunCandidateScore };
//# sourceMappingURL=runCandidateScore.js.map